import { http } from '../utils/axios';
import { ITag } from '../interfaces/tag.interface';

export interface ICreateTagPayload {
  name: string;
  color: string;
  textColor?: string;
  description?: string;
  scope?: {
    targetModel?: string;
    owner: {
      model: string;
      id?: string;
    };
  };
}

export type IUpdateTagPayload = Partial<ICreateTagPayload>;

export interface IAssociateTagPayload {
  tagId: string;
  orderId: string;
}

class TagService {
  private static instance: TagService;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  static getInstance(): TagService {
    if (!TagService.instance) {
      TagService.instance = new TagService();
    }

    return TagService.instance;
  }

  getAll = async () => {
    const { data } = await http<ITag[]>({
      url: '/tags',
      method: 'GET'
    });

    return data;
  };

  getOneTag = async (tagId: string) => {
    const { data } = await http<ITag>({
      url: `/tags/${tagId}`,
      method: 'GET'
    });

    return data;
  };

  createTag = async (payload: ICreateTagPayload) => {
    const { data } = await http<ITag>({
      url: '/tags',
      method: 'POST',
      data: payload
    });

    return data;
  };

  updateTag = async (payload: { id: string; data: IUpdateTagPayload }) => {
    const { data } = await http<ITag>({
      url: `/tags/${payload.id}`,
      method: 'PUT',
      data: payload.data
    });

    return data;
  };

  deleteTag = async (tagId: string) => {
    const { data } = await http<void>({
      url: `/tags/${tagId}`,
      method: 'DELETE'
    });

    return data;
  };

  associateTagWithOrder = async (payload: IAssociateTagPayload) => {
    const { data } = await http<void>({
      url: `/tags/orders/${payload.orderId}/tags`,
      method: 'POST',
      data: { tagId: payload.tagId }
    });

    return data;
  };

  disassociateTagFromOrder = async (payload: IAssociateTagPayload) => {
    const { data } = await http<void>({
      url: `/tags/orders/${payload.orderId}/tags/${payload.tagId}`,
      method: 'DELETE'
    });

    return data;
  };
}

const instance = TagService.getInstance();

export default instance;
